import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';

import Sortable from 'sortablejs';

import { VehicleFullColumnId } from '@src/app/enum/vehicle-full.enum';
import { IVehicleFullColumnSort } from '@src/app/interfaces/vehicle.interface';
import { sortByOrderId } from '@src/app/utils/common-fncs';
import { LOCAL_STORAGE_VAR } from '@src/app/utils/localstorage';
import { getConfigSavedListSortColumns } from '@src/app/utils/vehicle-list-fncs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-list-full-vehicle-column-config',
  templateUrl: './list-full-vehicle-column-config.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./list-full-vehicle-column-config.component.scss'],
})
export class ListFullVehicleColumnConfigComponent implements OnInit, AfterViewInit {
  @ViewChild('list') private listRef: ElementRef<HTMLElement>;

  @Output() public onSave$: EventEmitter<IVehicleFullColumnSort[]> = new EventEmitter();
  @Output() public onHide$: EventEmitter<void> = new EventEmitter();

  public readonly COLUMN_ID = VehicleFullColumnId;

  public readonly DEFAULT_COLUMNS_SORT = [
    { title: this.translate.instant('labels.name'), isVisible: true, id: VehicleFullColumnId.name, description: 'Opel Vivaro' },
    { title: this.translate.instant('labels.status'), isVisible: true, id: VehicleFullColumnId.status },
    { title: this.translate.instant('labels.time'), isVisible: true, id: VehicleFullColumnId.time, description: '25 min' },
    { title: this.translate.instant('labels.speed'), isVisible: true, id: VehicleFullColumnId.speed, description: '89 km/h' },
    { title: this.translate.instant('labels.address'), isVisible: true, id: VehicleFullColumnId.adress, description: 'PL, Kutno, Krótka 2' },
    { title: this.translate.instant('labels.driver'), isVisible: true, id: VehicleFullColumnId.driver, description: 'Adam Nowak' },
    { title: 'E-TOLL', isVisible: true, id: VehicleFullColumnId.etoll },
    { title: 'SENT', isVisible: true, id: VehicleFullColumnId.sent },
    { title: this.translate.instant('labels.gps'), isVisible: true, id: VehicleFullColumnId.gps },
    { title: this.translate.instant('labels.gsm'), isVisible: true, id: VehicleFullColumnId.gsm },
    { title: this.translate.instant('labels.fuel'), isVisible: true, id: VehicleFullColumnId.fuel, description: '45 L'},
    { title: this.translate.instant('vehicle-indicator.rpm'), isVisible: true, id: VehicleFullColumnId.rpm, description: '2100 rpm'},
    { title: this.translate.instant('sensors'), isVisible: true, id: VehicleFullColumnId.sensor },
    { title: this.translate.instant('labels.tacho'), isVisible: true, id: VehicleFullColumnId.tacho, description: 'Tachograf'},
    { title: this.translate.instant('deviceId'), isVisible: true, id: VehicleFullColumnId.numberId, description: '111100000' },
    { title: this.translate.instant('create-account.id'), isVisible: true, id: VehicleFullColumnId.id, description: '222200000' },
    { title: this.translate.instant('blocked'), isVisible: true, id: VehicleFullColumnId.lock },
    { title: this.translate.instant('networkType'), isVisible: true, id: VehicleFullColumnId.networkType, description: '2G/5G' },
  ];

  public columnsSort: any[] = [];
  public sortable: Sortable;

  constructor(private translate: TranslateService) {
    this.initList();
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.draggableInit();
  }

  public restoreDefaultConfig(): void {
    const defaultConfig: IVehicleFullColumnSort[] = [...this.DEFAULT_COLUMNS_SORT].map(item => ({ id: item.id, isVisible: true }));
    this.save(defaultConfig);
  }

  public save(data: IVehicleFullColumnSort[] = this.getSortedColumns()): void {
    localStorage.setItem(LOCAL_STORAGE_VAR.VEHICLE_FULL_LIST_SORT_COLUMNS_CONFIG, JSON.stringify(data));
    this.onSave$.emit(data);
  }

  private getSortedColumns(): IVehicleFullColumnSort[] {
    const sortedIds = this.sortable.toArray();
    const sortedColumns = sortedIds.map((item: string) => this.columnsSort.find(el => el.id == item as any));
    return sortedColumns.map((item) => ({ id: item!.id, isVisible: item!.isVisible }));
  }

  private initList(): void {
    const savedConfig = getConfigSavedListSortColumns();
    const defaultConfig = [...this.DEFAULT_COLUMNS_SORT].map(el => {
      const columnInSavedConfig = savedConfig.find(item => item.id === el.id);
      return {
        ...el,
        isVisible: columnInSavedConfig ? columnInSavedConfig.isVisible : true,
      }
    });
    this.columnsSort = sortByOrderId(savedConfig.map(item => item.id), defaultConfig);
  }

  private draggableInit(): void {
    this.sortable = Sortable.create(this.listRef.nativeElement, {
      handle: '.column',
      animation: 150,
      filter: '.no-drag',
      onMove: function (evt) {
        const targetElement = evt.related;
        const draggedElement = evt.dragged;
        if (targetElement.classList.contains('no-drag') || draggedElement.classList.contains('no-drag')) {
          return false;
        }
        return true;
      },
    });
  }
}
